<script setup lang="ts">
import { UtilsEdit } from "@easy/ui/utils";
import { useRenderPreviewStore } from "@/views/store/render-preview.store";
import { storeToRefs } from "pinia";

const renderPreviewStore = useRenderPreviewStore();
const { isPreview, isPageMode } = storeToRefs(renderPreviewStore);

defineEmits(["edit"]);
</script>

<template>
    <UtilsEdit :enabled="isPreview && !isPageMode" @edit="$emit('edit')">
        <slot></slot>
    </UtilsEdit>
</template>
